import { useEffect, useState } from 'react';
import { gql } from 'apollo-boost';
import measureDistance from '../../common/utils/measureDistance';
import client from '../graphql/client';

const GET_STATIONS = gql`
  query($lat: Float!, $lng: Float!, $status: String, $openStatus: String, $limit: Int) {
    stations(lat: $lat, lng: $lng, status: $status, open_status: $openStatus, limit: $limit) {
      id
      address {
        line_1
        line_2
      }
      brand_name
      brands {
        image_url
      }
      emergency_status {
        has_gas {
          report_status
          update_date
        }
        has_power {
          report_status
          update_date
        }
        has_diesel {
          report_status
          update_date
        }
      }
      fuels
      latitude
      longitude
      name
      phone
    }
  }
`;

const withDistance = ({ lat: fromLat, lng: fromLng } = {}) => station => ({
  ...station,
  distance: measureDistance(station.latitude, station.longitude, fromLat, fromLng),
});

const byDistance = (stationA, stationB) => {
  if (stationA.distance < stationB.distance) {
    return -1;
  }
  if (stationB.distance < stationA.distance) {
    return 1;
  }
  return 0;
};

export default function useStations({ lat, lng } = {}) {
  const [stations, setStations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function updateStations() {
      setIsLoading(true);

      const { data: { stations: results } } = await client.query({
        query: GET_STATIONS,
        variables: { lat, lng, limit: 100 },
      });

      setStations(
        results
          .map(station => ({ // GraphQL casts ids as strings, so we parse as int
            ...station,
            id: parseInt(station.id, 10),
          }))
          .map(withDistance({ lat, lng }))
          .sort(byDistance),
      );

      setIsLoading(false);
    }

    if (lat && lng) {
      updateStations();
    } else if (stations.length) {
      setStations([]);
    }
  }, [lat, lng, stations.length]);

  return [stations, { isLoading }];
}
